<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <p>{{titles}}</p>
         <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAddMore(1)">新增专家观点</el-button>
            <el-button type="primary" @click="doAddMore(2)">新增媒体观点</el-button>
          </div>
        </zv-table>
    <zv-dialog
      width="600px"
      :title="isEdit ? '修改' : '新增'"
      :showDialog.sync="showFormDialog"
      @close-dialog="closeFormDialog"
    >
      <div slot="content">
        <el-form
          ref="myForm"
          label-width="100px"
          :model="formData"
          :rules="formRules"
          status-icon
        >
          <el-form-item label="文章标题：">
            <span>{{titles}}</span>
          </el-form-item>
          <el-form-item label="发布人：" prop="creator_id">
            <el-select
              v-model="formData.creator_id"
              filterable
              clearable
            >
              <el-option
                v-for="item in creatorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="观点详情：" prop="content">
            <el-input type="textarea" :autosize="{ minRows: 7,minCols: 50}" v-model="formData.content" clearable></el-input>
          </el-form-item>
          <el-form-item label="启用状态：" prop="status">
            <el-switch
              v-model="formData.status"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div slot="btns">
        <el-button @click="showFormDialog = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </zv-dialog>
  </div>
   </div>
  </div>
</template>

<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import tokenService from "@/utils/services/token_service";
export default {
  name: "expertDatabase",
  mixins: [addFormMixin],
  data() {
    let vm = this;
    return {
      addressSelectData: null,
      addressItem: null,
      name: "",
      currentPage: 1,
      totalList: null,
      table: {
        api: api.articleOpinionList,
        query: {
          article_id: vm.$route.query.id,
        },
        searchData: [
          {
            type: "select",
            model: "creator_type",
            placeholder: "请选择观点",
            option: [
              {label: "全部观点", value: ""},
              {label: "专家观点", value: 1},
              {label: "媒体观点", value: 2}
            ]
          }
        ],
        columns: [
          {
            title: "观点类型",
            key: "creator_type",
            minWidth:"100",
            render(h, ctx) {
              return h("span", ctx.row.creator_type == 1 ? '专家观点':'媒体观点');
            }
          },
          {
            title: "发布情况",
            key: "title",
            minWidth:"100",
            render(h, ctx) {
              const editBtn = h(
                "p",
                ctx.row.create_username
              );

              const delBtn = h(
                "p",
                vm.$commFunc.formatDate(ctx.row.add_time)
              );

              let arr = [];
              arr.push(editBtn);
              arr.push(delBtn);
              return h("span", arr);
            }
          },
          {
            title: "观点详情",
            key: "content",
            minWidth:"200",
            // showTooltip: true
          },
          {
            title: "启用状态",
            key: "status",
            minWidth: "80",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.status,
                  "inactive-value": 0,
                  "active-value": 1
                  // "inactive-text": "关闭",
                  // "active-text": "开启"
                },
                on: {
                  change(status) {
                    vm.doChangeStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"

              );

              let arr = [];
              arr.push(editBtn);
              arr.push(delBtn);
              return h("span", arr);
            }
          }
        ]
      },
      adddApi: api.articleOpinionAdd,
      editApi: api.articleOpinionEdit,
      deleteApi: api.articleOpinionDelete,
      addSuccessMsg: '添加成功',
      editSuccessMsg: '编辑成功',
      deleteSuccessMsg: '删除成功',
      formRules: {
        content: [{
          required: true,
          message: "观点详情不能为空",
          trigger: "blur"
        }],
        creator_id: [{
          required: true,
          message: "发布人不能为空",
          trigger: "change"
        }]
      },
      titles: '',
      creatorList: '',
      formData: {
        
      },
      formDataOri: {

      }
    };
  },
  created() {
    this.getData();
    this.creatorListFn()
  },
  methods: {
    // 获取数据
    getData() {
      let datas = {
        article_id: this.$route.query.id,
      }
      api
        .articleOpinionList(datas)
        .then(res => {
          this.titles = res.article_title
        })
        .catch(err => {
          // console.log(err);
        });
    },
    async doChangeStatus(status, id) {
       await api.articleOpinionEdit({
        id,
        status: status
      });
      this.$refs.dataTable.refresh();
      this.$message.success("状态修改成功!");
    },

    // 发布人下拉菜单
    creatorListFn() {
      api
        .expertList()
        .then(res => {
          this.creatorList = res.list
        })
        .catch(err => {
          // console.log(err);
        });
    },

    // 查询参数
    // queryData() {
    //   let data = {
    //     name: this.name
    //   };
    //   if (data.name) {
    //     this.getData(data);
    //   } else {
    //     this.getData();
    //   }
    // },

    // 新增数据
    doAddMore(index) {
      this.$set(this.formData,"article_id",this.$route.query.id)
      this.$set(this.formData,"creator_type",index)
      console.log(this.formData)
      this.formDataOri = this.formData
      this.doAdd()
    },


    // 删除数据
    deleteData(row) {
      debugger;
      let data = {
        id: row.id
      };
      this.$confirm("确定删除该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(data);
        })
        .catch(() => {});
    },

    delete(data) {
      api
        .recordedDelete(data)
        .then(res => {
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.getData();
        })
        .catch(err => {});
    },

    //改变每页显示数量重新请求数据，重置当前页为第一页
    handleSizeChange(val) {
      let pageSize = { pagesize: val };
      this.getData(pageSize);
    },

    //点击改变当前页
    handleCurrentChange(val) {
      let page = { page: val };
      this.getData(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>